/* eslint-disable no-unused-vars */
import { useSelector } from 'react-redux';
import { isPublisherRole } from 'store/selectors';
import { AdvertiserPayments } from './advertiserPayments/AdvertiserPayments';
import { PublisherPayments } from './publisherPayments/PublisherPayments';
import { Palette } from 'config';
import styled from 'styled-components';

export const PaymentMethodsSection = () => {
  const isPublisher = useSelector(isPublisherRole); // || true; // - to test publisher payments

  return (
    <>
      <Heading>Payment Methods</Heading>
      {isPublisher ? <PublisherPayments /> : <AdvertiserPayments />}
    </>
  );
};

export const Heading = styled.h2`
  font-weight: 600;
  font-size: 24px;
  line-height: 32px;
  margin-bottom: 32px;
  color: ${Palette.PrimaryGray._900};
`;
